import { render, staticRenderFns } from "./ContentChain.vue?vue&type=template&id=3b7362fc&scoped=true&"
import script from "./ContentChain.vue?vue&type=script&lang=js&"
export * from "./ContentChain.vue?vue&type=script&lang=js&"
import style0 from "./ContentChain.vue?vue&type=style&index=0&id=3b7362fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7362fc",
  null
  
)

export default component.exports